/**
 * Выбранный вид, которого нет ни в одном из списков селектора.
 *
 * `<select>` без совпавшего пункта показывает ПЕРВЫЙ — в кабинете это «Все
 * виды». Состояние при этом остаётся прежним: карта продолжает рисовать вид, а
 * подпись над ней утверждает, что вид не выбран. Ошибка тем хуже, что выглядит
 * не поломкой, а осмысленным экраном.
 *
 * Вернувшийся id — сигнал компоненту дорисовать пункт-сироту: «вид выбран,
 * справочник его не знает». Чинить сам справочник — не его дело.
 */
import type { SpeciesItem } from '../api'

export function orphanSpecies(
  value: number | null,
  inView: SpeciesItem[],
  outOfView: SpeciesItem[],
): number | null {
  if (value == null) return null
  const known = (s: SpeciesItem) => s.species_id === value
  return inView.some(known) || outOfView.some(known) ? null : value
}
